import { ReactNode } from "react";

import styled from "styled-components";

interface CenterIcon {
  icon: ReactNode;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CenterIcon = ({ icon }: CenterIcon) => {
  return <Container>{icon}</Container>;
};

export default CenterIcon;
